import React from 'react';
import { iconsMapping } from '../../../Switcher/SwitcherItems/iconsMapping';
import { ButtonIcon } from '@qualtrics/ui-react/icons';
import { NavigationLabel } from './NavigationLabel';

export const getVisibleSuperTabs = (superTabs) => {
  const visibleSuperTabs = superTabs.filter(
    (superTab) =>
      superTab.visible &&
      (!!superTab.sectionTabs ||
        superTab.sectionTabs?.some((sectionTab) => sectionTab.visible)),
  );
  return visibleSuperTabs.map((superTab) => {
    superTab.sectionTabs
      ?.filter(
        (sectionTab) =>
          sectionTab.visible &&
          (!!sectionTab.subTabs ||
            sectionTab.subTabs?.some((subTab) => subTab.visible)),
      )
      ?.map((sectionTab) => {
        sectionTab.subTabs
          ?.filter((subTab) => subTab.visible)
          ?.map((subTab) => {
            return subTab;
          });
        return sectionTab;
      });
    return superTab;
  });
};

const getDeepestElement = ({ superTab, sectionTab, subTab }) => {
  if (subTab) {
    return subTab;
  } else if (sectionTab) {
    return sectionTab;
  } else {
    return superTab;
  }
};

export const createNavigationEntry = (
  { superTab, sectionTab, subTab },
  searchString,
) => {
  const deepestElement = getDeepestElement({ superTab, sectionTab, subTab });
  const itemId =
    [superTab?.nameKey, sectionTab?.nameKey, subTab?.nameKey]
      .filter(Boolean)
      .join('/') || deepestElement.href;
  return {
    label: (
      <NavigationLabel
        superTab={superTab}
        sectionTab={sectionTab}
        subTab={subTab}
        searchString={searchString}
      />
    ),
    searchLabel: deepestElement.name,
    itemId,
    action: () => {
      window.location.href = deepestElement.href;
    },
    icon: {
      Icon: iconsMapping[superTab.v2Info?.contextType] || ButtonIcon,
    },
  };
};

export const flattenSuperTabs = (superTabs) => {
  const flattenedSuperTabs = superTabs.flatMap((superTab) => {
    const sectionTabItems =
      superTab.sectionTabs?.flatMap((sectionTab) => {
        const subTabItems =
          sectionTab.subTabs
            ?.map((subTab) => ({
              superTab,
              sectionTab,
              subTab,
            }))
            .filter(
              (subTab) =>
                subTab.nameKey !== sectionTab.nameKey &&
                subTab.href !== sectionTab.href,
            ) || [];
        return [...subTabItems, { superTab, sectionTab }];
      }) || [];

    if (
      sectionTabItems.length === 1 &&
      sectionTabItems[0].sectionTab.nameKey === superTab.nameKey &&
      sectionTabItems[0].sectionTab.href === superTab.href
    ) {
      return [{ superTab }];
    } else {
      return [...sectionTabItems, { superTab }];
    }
  });

  return flattenedSuperTabs;
};

export const getSuperTabsEntries = (superTabs) => {
  return superTabs;
};
